import { ReactNode } from 'react';
import { ErrorBoxAction, ErrorBoxActionType } from '../errorBox/errorBoxActionType';

export interface IErrorBoxState {
    errorBoxMessage: ReactNode;
}
export function errorBoxReducer(
    state: IErrorBoxState = {
        errorBoxMessage: null,
    },
    action: ErrorBoxAction,
): IErrorBoxState {
    const { errorBoxMessage } = state;
    let newErrorBoxMessage: ReactNode = errorBoxMessage;
    switch (action.type) {
        case ErrorBoxActionType.ADD_BOX_WARNING:
            newErrorBoxMessage = action.payload.errorBoxMessage;
            return {
                ...state,
                errorBoxMessage: newErrorBoxMessage,
            };
        case ErrorBoxActionType.REMOVE_BOX_WARNING:
            return {
                ...state,
                errorBoxMessage: null,
            };
        default:
            return state;
    }
}
